import type { InvokeOutcome } from '../lib/api';

export function OutcomeView({ outcome }: { outcome: InvokeOutcome }) {
  switch (outcome.status) {
    case 'ok':
      return (
        <div>
          <span className="ok">Done.</span>
          <pre>
            {outcome.result.structured
              ? JSON.stringify(outcome.result.structured, null, 2)
              : outcome.result.text}
          </pre>
        </div>
      );
    case 'tool_error':
      return (
        <div>
          <span className="error">The connector reported an error.</span>
          <pre>{outcome.result.text}</pre>
        </div>
      );
    case 'denied':
      return <p className="warn">Denied: {outcome.reason}</p>;
    case 'failed':
      return <p className="error">Failed: {outcome.error}</p>;
  }
}
